export default __webpack_public_path__ + "static/media/Figtree-Light.63b97f17.ttf";